<template>
  <a
    :href="offerAbsoluteUrl"
    target="_blank"
    class="offer-code"
  >
    <a-icon
      type="link"
      :style="{ marginRight: '4px' }"
    />
    <slot
      v-if="hasSlot('content')"
      name="content"
    />
    <template v-else>
      {{ offerCode }}
    </template>
  </a>
</template>

<script>
export default {
  name: "OfferCode",
  props: {
    slug: {
      type: String,
      required: true
    },
    productCode: {
      type: String,
      required: true
    },
    offerCode: {
      type: String,
      required: true
    }
  },
  computed: {
    offerAbsoluteUrl() {
      const MARKETPLACE_URL = process.env.VUE_APP_MARKETPLACE_URL

      return `${MARKETPLACE_URL}/product/${this.slug}/${this.productCode}/${this.offerCode}`
    }
  },
  methods: {
    hasSlot(slotName) {
      return slotName in this.$slots
    }
  }
}
</script>

<style lang="scss" scoped>
.offer-code {
  overflow: hidden;
  white-space: nowrap;
}
</style>
